module.exports = __webpack_public_path__ + "img/iso_background_card.9633a79.svg";